import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import * as getters from "./getters";
// import LogRocket from "logrocket";
import mutations from "./mutations";
import defaultState from "./defaultState";
// @ts-ignore
// import createPlugin from "logrocket-vuex";

// disable logrocket
// const logrocketPlugin = createPlugin(LogRocket);

Vue.use(Vuex);

export default new Vuex.Store({
  // plugins: [logrocketPlugin],
  state: defaultState(),
  actions,
  getters,
  mutations
});
